import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ControlGroup } from '../ControlGroup/ControlGroup';
import Popover from '../Popover/Popover';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
    onClosed = _ref.onClosed,
    scrollbarWrapperHeight = _ref.scrollbarWrapperHeight,
    scrollbarMaxHeight = _ref.scrollbarMaxHeight,
    dataTestId = _ref.dataTestId,
    role = _ref.role,
    autoFocusList = _ref.autoFocusList;
  var _useState = useState(true),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var dropdownRef = useRef();
  useEffect(function () {
    var handleDocumentClick = function handleDocumentClick(event) {
      if (isOpen && dropdownRef && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleDocumentClick, true);
    return function () {
      document.removeEventListener('click', handleDocumentClick, true);
    };
  }, [isOpen]);
  var handleClosedOnEsc = function handleClosedOnEsc() {
    if (onClosed) {
      onClosed(false);
    }
  };
  if (!isOpen) {
    if (onClosed) {
      onClosed(false);
    }
    return null;
  }
  return ___EmotionJSX("span", {
    ref: function ref(node) {
      dropdownRef.current = node;
    }
  }, ___EmotionJSX(Popover, {
    handleClosed: handleClosedOnEsc
  }, ___EmotionJSX(ControlGroup, {
    scrollbarWrapperHeight: scrollbarWrapperHeight,
    scrollbarMaxHeight: scrollbarMaxHeight,
    dataTestId: dataTestId,
    autoFocusList: autoFocusList,
    role: role
  }, children)));
};
Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  onClosed: PropTypes.func,
  scrollbarWrapperHeight: PropTypes.number,
  scrollbarMaxHeight: PropTypes.bool,
  dataTestId: PropTypes.string,
  role: PropTypes.string,
  autoFocusList: PropTypes.bool
};
Dropdown.defaultProps = {
  role: 'listbox',
  autoFocusList: true
};
export default Dropdown;